// extracted by mini-css-extract-plugin
export default {"products":"ow-z","card":"pw-z","oosMessaging":"qw-z"};